import { Dish, OrderItem } from '../apiTypes';
import { BillCalc, getOrderItemPriceWithMods } from './getBillCalc';
import { isNotNull } from './isNotNull';
import { Map } from './map';

export type PrroItem = {
  quantity: number;
  is_return: boolean;
  good: {
    code: string;
    name: string;
    price: number;
    tax: string[];
    uktzed?: string;
    barcode?: string;
    excise_barcodes?: string[];
  };
};

export const getPrroItems = (orderItems: OrderItem[], dishesMap: Map<DbDocument<Dish>>): PrroItem[] =>
  Object.values(
    orderItems.reduce<Record<string, PrroItem>>((acc, i) => {
      const dish = dishesMap[i.dishId];
      const price = getOrderItemPriceWithMods(i);

      if (dish) {
        const modNames = (i.modifications || []).filter((mod) => mod.price).map((mod) => mod.name);
        const key = i.dishId + modNames.join('');
        const prevItem = acc[key];
        return {
          ...acc,
          [key]: prevItem
            ? {
                ...prevItem,
                quantity: prevItem.quantity + (i.byWeight ? Number(i.weight || i.defaultWeight) : 1000),
              }
            : {
                quantity: i.byWeight ? Number(i.weight || i.defaultWeight) : 1000,
                is_return: false,
                good: {
                  code: dish.id,
                  name: modNames.length ? `${dish.name} (${modNames.join(', ')})` : dish.name,
                  price: i.byWeight ? (price * 1000) / Number(i.defaultWeight) : price,
                  tax: dish.taxInfo?.checboxTaxCodes || [],
                  uktzed: dish.taxInfo?.uktzed || undefined,
                  barcode: dish.taxInfo?.barcode || undefined,
                  excise_barcodes: i.excises
                    ? Object.values(i.excises)
                        .map((excise) => excise.value)
                        .filter(isNotNull)
                    : undefined,
                },
              },
        };
      }
      return acc;
    }, {})
  );

export const getPrroDiscounts = (legalEntityId: string, billCalc: BillCalc, discount: number, service: number) => {
  const discounts = [];
  const { promotionsSum, discountSum, serviceSum } = billCalc.byLegalEntity[legalEntityId] || {};
  if (promotionsSum) {
    discounts.push({ mode: 'VALUE', type: 'DISCOUNT', value: promotionsSum, name: 'Акційна знижка' });
  }
  if (discountSum) {
    discounts.push({ mode: 'PERCENT', type: 'DISCOUNT', value: discount, name: 'Знижка' });
  }
  if (serviceSum) {
    discounts.push({ mode: 'PERCENT', type: 'EXTRA_CHARGE', value: service, name: 'Обслуговування' });
  }
  return discounts;
};
